import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Time from 'react-time';
import AppActions from '../../actions/app-actions';
import Loader from '../common/loader';
import { Typography } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import { showError } from '../../helpers';

const DeviceHistoryExpanded = (props) => {
  const [state, setState] = useState({ statusHistory: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AppActions.getDeviceHistroyDetails(props.uuid)
      .then(res => {
        const statusHistory = [];
        if (Array.isArray(res.results)) {
          res.results.forEach(({series=[]}) => {
            series.forEach(({values=[]}) => {
              values.forEach(val => {
                statusHistory.push({time: val[0], status: val[1]});
              });
            });
          });
          setState(prev => ({ ...prev, statusHistory }));
        }
      })
      .catch(err => {
        showError(err, `Device status history couldn't be loaded.`);
      })
      .finally(() => {
        setLoading(false);
      });
    return () => {};
  }, []);

  const content = () => {
    if (loading) {
      return (
        <Loader show={true} />
      );
    } else {
      if (!state.statusHistory.length) {
        return (
          <ListItem style={{ justifyContent: 'center' }}>
            <Typography>History of status is empty</Typography>
          </ListItem>
        )
      } else {
        return (
          <Table>
            <TableHead>
              <TableRow>
                {
                  ['Time', 'Status'].map((txt, idx) => {
                    return (
                      <TableCell key={idx} align='center'>{txt}</TableCell>
                    );
                  })
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {
                state.statusHistory.map(({status='', time=''}, idx) => {
                  return (
                    <TableRow key={idx}>
                      <TableCell align='center' style={{ padding: 12 }}>
                        <Time value={time} format="YYYY-MM-DD HH:mm" />
                      </TableCell>
                      <TableCell align='center' style={{ padding: 12 }}>{`${status[0].toUpperCase()}${status.slice(1)}`}</TableCell>
                    </TableRow>
                  );
                })
              }
            </TableBody>
          </Table>
        );
      }
    }
  };

  return (
    <div style={{ border: '1px solid #d4e9e7', marginTop: 10, padding: '5px 20px' }}>
      {content()}
    </div>
  );
};

DeviceHistoryExpanded.propTypes = {
  uuid: PropTypes.string.isRequired
};

export default DeviceHistoryExpanded;